var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4528 0.336771C10.7229 0.602133 10.739 1.0495 10.4888 1.33598L4.48481 8.21106C3.99317 8.77403 3.17335 8.77403 2.68171 8.21106L0.17757 5.34362C-0.072621 5.05711 -0.0564733 4.60975 0.213642 4.34439C0.48375 4.07903 0.905548 4.09621 1.15574 4.38264L3.58326 7.16234L9.51073 0.37503C9.76093 0.0885404 10.1827 0.0714152 10.4528 0.336771ZM13.7864 0.336771C14.0564 0.602133 14.0726 1.0495 13.8224 1.33598L7.81837 8.21106C7.56818 8.49749 7.14638 8.51468 6.87626 8.24931C6.60613 7.98395 6.59 7.53659 6.84019 7.25008L12.8443 0.37503C13.0945 0.0885404 13.5163 0.0714152 13.7864 0.336771Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTick);
export default __webpack_public_path__ + "static/media/double-tick.1d67acc1fbfd269ac12c93f58a314be5.svg";
export { ForwardRef as ReactComponent };